import { Injectable, Inject } from '@angular/core';
import { UnitObject } from '../models/UnitObject';
import { Unit } from '../models/Enums';

@Injectable({ providedIn: "root" })

export class ConversionService {

  public GetAvailableUnits(Measure: string): UnitObject[] {
    var units = [];

    switch (Measure) {
      case "BusVoltage":
        units.push(new UnitObject("Vrms", Unit.Vrms, this));
        break;
      case "InsulationClass":
        //units.push(new UnitObject("", 0));
        break;
      case "AirGap":
        units.push(new UnitObject("in", Unit.in, this));
        units.push(new UnitObject("mm", Unit.mm, this));
        break;
      case "Poles":
        units.push(new UnitObject("", Unit.blank, this));
        units.push(new UnitObject("pair", Unit.blank, this));
        break;
      case "Resistance":
        units.push(new UnitObject("Ohms", Unit.Ohms, this));
        break;
      case "Inductance":
        units.push(new UnitObject("mH", Unit.mH, this));
        break;
      case "TorqueConstant":
        units.push(new UnitObject("N-m/Apeak", Unit.NmAPeak, this));
        units.push(new UnitObject("in-lb/Apeak", Unit.inlbAPeak, this));
        break;
      case "BackEMFConstant":
        units.push(new UnitObject("Vpeak/kRPM", Unit.vPeakKRPM, this));
        break;
      case "Frequency":
        units.push(new UnitObject("Hz", Unit.Hz, this));
        break;
      case "MaxSpeed":
        units.push(new UnitObject("RPM", Unit.RPM, this));
        break;
      case "BaseRotaryInertia":
        units.push(new UnitObject("kg-cm^2", Unit.kgCMSQ, this));
        units.push(new UnitObject("lb-in", Unit.lbIn, this));
        break;
      case "MaxAccel":
        units.push(new UnitObject("rad/s^2", Unit.radSSQ, this));
        break;
      case "ContinStallTorque":
        units.push(new UnitObject("N-m", Unit.Nm, this));
        units.push(new UnitObject("in-lb", Unit.inLb, this));
        break;
      case "ContinStallCurrent":
        units.push(new UnitObject("Arms", Unit.Arms, this));
        break;
      case "RatedTorque":
        units.push(new UnitObject("N-m", Unit.Nm, this));
        units.push(new UnitObject("in-lb", Unit.inLb, this));
        break;
      case "RatedSpeed":
        units.push(new UnitObject("RPM", Unit.RPM, this));
        break;
      case "RatedCurrent":
        units.push(new UnitObject("Arms", Unit.Arms, this));
        break;
      case "RatedPower":
        units.push(new UnitObject("kW", Unit.kW, this));
        units.push(new UnitObject("Hp", Unit.Hp, this));
        break;
      case "PeakTorque":
        units.push(new UnitObject("N-m", Unit.Nm, this));
        units.push(new UnitObject("in-lb", Unit.inLb, this));
        break;
      case "PeakCurrent":
        units.push(new UnitObject("Arms", Unit.Arms, this));
        break;
      case "ThermalTimeConstant":
        units.push(new UnitObject("seconds", Unit.s, this));
        break;
      case "ThermalResistance":
        units.push(new UnitObject("C/W", Unit.CW, this));
        break;
      case "MaxWindingTemp":
        units.push(new UnitObject("°C", Unit.Cels, this));
        units.push(new UnitObject("°F", Unit.Fahr, this));
        break;
      case "MagnetStacks":
        break;
      default:
        units.push(new UnitObject("", 0, this));
        break;
    }

    return units;
  }

  public GetUnitFromString(unitString: string): Unit {
    var retEnum;
    switch (unitString) {
      case "APeak":
        retEnum = Unit.APeak;
        break;
      case "Arms":
        retEnum = Unit.Arms;
        break;
      case "A":
        retEnum = Unit.A;
        break;
      case "bits":
      case "Bits":
        retEnum = Unit.bits;
        break;
      case "Cels":
      case "Celc":
      case "C":
      case "\u1D52C":
        retEnum = Unit.Cels;
        break;
      case "CycleResST":
        retEnum = Unit.CycleResST;
        break;
      case "CycleResPPR":
        retEnum = Unit.CycleResPPR;
        break;
      case "CountsPerCycle1":
        retEnum = Unit.CountsPerCycle1;
        break;
      case "CountsPerCycle2048":
        retEnum = Unit.CountsPerCycle2048;
        break;
      case "CountsPerRevPPR":
        retEnum = Unit.CountsPerRevPPR;
        break;
      case "CountsPerRevST":
        retEnum = Unit.CountsPerRevST;
        break;
      case "Fahr":
      case "F":
      case "\u1D52F":
        retEnum = Unit.Fahr;
        break;
      case "kHz":
        retEnum = Unit.kHz;
        break;
      case "Hz":
        retEnum = Unit.Hz;
        break;
      case "in":
        retEnum = Unit.in;
        break;
      case "in-lb":
      case "inLb":
        retEnum = Unit.inLb;
        break;
      case "mm":
        retEnum = Unit.mm;
        break;
      case "In-Lb/APeak":
      case "in-lb/Apeak":
      case "inlbAPeak":
        retEnum = Unit.inlbAPeak;
        break;
      case "lbFtA":
      case "lbfta":
      case "lbftA":
        retEnum = Unit.lbFtA;
        break;
      case "lbftSQ":
      case "lbFtSQ":
        retEnum = Unit.lbFtSQ;
        break;
      case "Kg-CM\u00B2":
      case "kg-cm^2":
      case "Kg-cm^2":
      case "kgCMSQ":
        retEnum = Unit.kgCMSQ;
        break;
      case "kgMSQ":
        retEnum = Unit.kgMSQ;
        break;
      case "lb-in":
      case "Lb-in":
      case "lbIn":
        retEnum = Unit.lbIn;
        break;
      case "mH":
        retEnum = Unit.mH;
        break;
      case "mHZ":
      case "mHz":
        retEnum = Unit.mHZ;
        break;
      case "Nm":
      case "N-m":
        retEnum = Unit.Nm;
        break;
      case "NmA":
        retEnum = Unit.NmA;
        break;
      case "Nm/APeak":
        retEnum = Unit.NmAPeak;
        break;
      case "NmArms":
        retEnum = Unit.NmArms;
        break;
      case "\u03A9":
      case "Ohms":
        retEnum = Unit.Ohms;
        break;
      case "rad/s\u00B2":
      case "rad/sSQ":
        retEnum = Unit.radSSQ;
        break;
      case "revs":
      case "revolutions":
        retEnum = Unit.revs;
        break;
      case "tenPowkgmSQ":
        retEnum = Unit.tenPowkgmSQ;
        break;
      case "VPeak/kRPM":
      case "vPeakKRPM":
        retEnum = Unit.vPeakKRPM;
        break;
      case "VrmsKrpm":
        retEnum = Unit.VrmsKrpm;
        break;
      case "vKRPM":
        retEnum = Unit.vKRPM;
        break;
      case "mvRPM":
      case "mVRPM":
        retEnum = Unit.mVRPM;
        break;
      case "seconds":
      case "s":
        retEnum = Unit.s;
        break;
      case "min":
      case "minutes":
        retEnum = Unit.min;
        break;
      case "CW":
      case "C/W":
        retEnum = Unit.CW;
        break;
      case "kw":
      case "kW":
        retEnum = Unit.kW;
        break;
      case "hp":
      case "Hp":
      case "HP":
        retEnum = Unit.Hp;
        break;
      case "Vrms":
        retEnum = Unit.Vrms;
        break;
      case "RPM":
        retEnum = Unit.RPM;
        break;
      case "poles":
        retEnum = Unit.poles;
        break;
      case "pair":
      case "pole pairs":
      case "polepairs":
        retEnum = Unit.polepairs;
        break;
      case "SinePPR":
      case "sineppr":
        retEnum = Unit.SinePPR;
        break;
      case "microsecond":
        retEnum = Unit.microsecond;
        break;
      case "turns":
        retEnum = Unit.turns;
        break;
      case "V":
        retEnum = Unit.V;
        break;
      default:
        retEnum = Unit.blank;
        break;
    }

    return retEnum;
  }


  public GetUnitDisplayText(unit: Unit): string {
    var text = "";
    switch (+unit) {
      case Unit.APeak:
        text = "APeak";
        break;
      case Unit.Arms:
        text = "Arms";
        break;
      case Unit.A:
        text = "A";
        break;
      case Unit.bits:
        text = "bits";
        break;

      case Unit.Cels:
        text = '\u1D52C';
        break;
      case Unit.CycleResPPR:
      case Unit.CycleResST:
        text = "Feedback Cycles/Rev"
        break;
      case Unit.CountsPerCycle1:
      case Unit.CountsPerCycle2048:
        text = "Feedback Counts per Cycle";
        break;
      case Unit.CountsPerRevPPR:
      case Unit.CountsPerRevST:
        text = "Feedback Counts per Rev";
        break;
      case Unit.Fahr:
        text = "\u1D52F";//\xB0C
        break;
      case Unit.kHz:
        text = "kHz";
        break;
      case Unit.Hz:
        text = "Hz";
        break;
      case Unit.in:
        text = "in";
        break;
      case Unit.inlbAPeak:
        text = "In-Lb/APeak";
        break;
      case Unit.lbFtA:
        text = "lb-ft/A";
        break;
      case Unit.kgCMSQ:
        text = "Kg-CM\u00B2";
        break;
      case Unit.kgMSQ:
        text = "Kg-M\u00B2";
        break;
      case Unit.lbIn:
        text = "lb-in";
        break;
      case Unit.lbFtSQ:
        text = "lbft\u00B2";
        break;
      case Unit.tenPowkgmSQ:
        text = "10^-4kgm\u00B2"
        break;
      case Unit.mH:
        text = "mH";
        break;
      case Unit.mHZ:
        text = "mHz";
        break;
      case Unit.mm:
        text = "mm";
        break;
      case Unit.Nm:
        text = "Nm";
        break;
      case Unit.NmA:
        text = "Nm/A";
        break;
      case Unit.NmAPeak:
        text = "Nm/APeak";
        break;
      case Unit.NmArms:
        text = "Nm/Arms"
        break;
      case Unit.Ohms:
        text = "\u03A9";
        break;
      case Unit.radSSQ:
        text = "rad/s\u00B2";
        break;
      case Unit.revolutions:
        text = "revolutions";
        break;
      case Unit.revs:
        text = "revs";
        break;
      case Unit.vPeakKRPM:
        text = "Vpeak/kRPM";
        break;
      case Unit.vKRPM:
        text = "V/kRPM";
        break;
      case Unit.Vpk:
        text = "Vpeak";
        break;
      case Unit.VrmsKrpm:
        text = "Vrms/kRPM"
        break;
      case Unit.Vrms:
        text = "Vrms";
        break;
      case Unit.V:
        text = "V";
        break;
      case Unit.mVRPM:
        text = "mv/RPM";
        break;
        break;
      case Unit.CW:
        text = "C/W";
        break;
      case Unit.Hp:
        text = "Hp";
        break;
      case Unit.inLb:
        text = "in-lb";
        break;
      case Unit.kW:
        text = "kW";
        break;
      case Unit.RPM:
        text = "RPM";
        break;
      case Unit.s:
        text = "seconds";
        break;
      case Unit.min:
        text = "minutes";
        break;
      case Unit.polepairs:
        text = "pole pairs";
        break;
      case Unit.poles:
        text = "poles";
        break;
      case Unit.pair:
        text = "pairs";
        break;
      case Unit.microsecond:
        text = "µs";
        break;
      case Unit.turns:
      case Unit.blank:
      default:
        text = "";
        break;
    }
    return text;
  }

  public ConvertValue(sourceValue: number, sourceUnit: UnitObject, targetUnit: UnitObject) {
    var finalValue = 0;
    switch (+sourceUnit.Unit) {
      case Unit.APeak:
        if (targetUnit.Unit == Unit.A || targetUnit.Unit == Unit.Arms) {
          finalValue = this.aPkToA(sourceValue);
        }
        
        break;
      case Unit.A:
        if (targetUnit.Unit == Unit.Arms) {
          return sourceValue;
        }
        else if (targetUnit.Unit == Unit.APeak) {
          finalValue = this.AToAPeak(sourceValue);
        }
        break;
      case Unit.Arms:
        if (targetUnit.Unit == Unit.A) {
          return sourceValue;
        }
        else if (targetUnit.Unit == Unit.APeak) {
          finalValue = this.AToAPeak(sourceValue);
        }
        
        break;
        
      case Unit.Cels:
      case Unit.C:
        finalValue = this.CelcToFahr(sourceValue);
        break;
      case Unit.F:
      case Unit.Fahr:
        finalValue = this.FahrToCelc(sourceValue);
        break;
      case Unit.kHz:
        finalValue = this.kHzToHz(sourceValue);
        break;
      case Unit.Hz:
        finalValue = this.HzTokHZ(sourceValue);
        break;
      case Unit.in:
        finalValue = this.InToMm(sourceValue);
        break;
      case Unit.inLb:
        finalValue = this.InLbToNm(sourceValue);
        break;
      case Unit.inlbAPeak:
        if (targetUnit.Unit == Unit.NmA) {
          finalValue = this.NmAPKToNmA(this.InLbAPeakToNmAPeak(sourceValue));
        } else if (targetUnit.Unit == Unit.NmAPeak) {
          finalValue = this.InLbAPeakToNmAPeak(sourceValue);
        }
        else if (targetUnit.Unit == Unit.NmArms) {
          finalValue = this.NmAPKToNmA(this.InLbAPeakToNmAPeak(sourceValue));
        }
        
        break;
      case Unit.kgCMSQ:        
        if (targetUnit.Unit == Unit.kgMSQ) {
          finalValue = this.kgcmSqTokgMSq(sourceValue);
        }
        else if (targetUnit.Unit == Unit.lbFtSQ) {
          finalValue = this.lbinSqTolbFtSq(this.KgCMSqToLbIn(sourceValue));
        }
        else if (targetUnit.Unit == Unit.lbInSQ) {
          finalValue = this.KgCMSqToLbIn(sourceValue);
        }
        else if (targetUnit.Unit == Unit.tenPowkgmSQ) {
          finalValue = this.kgcmSqToYaskawaValue(sourceValue);
        }
        break;
      case Unit.lbIn:
        if (targetUnit.Unit == Unit.kgCMSQ) {
          finalValue = this.LbInToKgCMSq(sourceValue);
        }
        else if (targetUnit.Unit == Unit.kgMSQ) {
          finalValue = this.kgcmSqTokgMSq(this.LbInToKgCMSq(sourceValue));
        }
        else if (targetUnit.Unit == Unit.lbFtSQ) {
          finalValue = this.lbinSqTolbFtSq(sourceValue);
        }
        break;
      case Unit.mH:
        finalValue = sourceValue;
        break;
      case Unit.mm:
        finalValue = this.MmToIn(sourceValue);
        break;
      case Unit.Nm:
        finalValue = this.NmToInLb(sourceValue);
        break;
      case Unit.NmA:
        finalValue = this.NmAToNmAPeak(sourceValue);
        break;
      case Unit.NmAPeak:
        finalValue = this.NmAPeakToInLbAPeak(sourceValue);
        break;
      case Unit.Hp:
        finalValue = this.HPToKW(sourceValue);
        break;
      case Unit.kW:
        finalValue = this.KWToHP(sourceValue);
        break;
        
      case Unit.SinePPR:
        if (targetUnit.Unit == Unit.CountsPerRevPPR) {
          finalValue = sourceValue * 2048;
        }
        else if (targetUnit.Unit == Unit.CycleResPPR) {
          finalValue = sourceValue;
        }
        else if (targetUnit.Unit == Unit.bits) {
          finalValue = this.SinePPRToInterpolationFactor(sourceValue);
        }
        break;
      case Unit.bits:
        if (targetUnit.Unit == Unit.revolutions || targetUnit.Unit == Unit.revs) {
          finalValue = this.bitsToRevolutions(sourceValue);
        }
        else if (targetUnit.Unit == Unit.turns) {
          finalValue = this.bitsToTurns(sourceValue);
        }
        else if (targetUnit.Unit == Unit.CountsPerRevST) {
          finalValue = this.bitsToRevolutions(sourceValue) * 1.0;
        }
        else if (targetUnit.Unit == Unit.CycleResST) {
          finalValue = this.bitsToRevolutions(sourceValue);
        }
        break;
      case Unit.CountsPerRevPPR:
        finalValue = sourceValue * 2048;
        break;
      case Unit.CountsPerRevST:
        finalValue = this.bitsToRevolutions(sourceValue) * 1.0;
        break;
      case Unit.CycleResST:
        finalValue = this.bitsToRevolutions(sourceValue);
        break;
      case Unit.CycleResPPR:
        finalValue = sourceValue;
        break;
      case Unit.revolutions:
      case Unit.revs:
        finalValue = this.RevolutionsToBits(sourceValue);
        break;
      case Unit.steps:
        finalValue = this.bitsToRevolutions(sourceValue);
        break;
      case Unit.vPeakKRPM:
        if (targetUnit.Unit == Unit.V) {
          finalValue = this.vPkToV(sourceValue);
        }
        else if (targetUnit.Unit == Unit.vKRPM) {
          finalValue = this.VPkKRPMTovKRPM(sourceValue);
        }
        else if (targetUnit.Unit == Unit.mVRPM) {
          finalValue = this.VPkKRPMTovKRPM(sourceValue);
        }
        else if (targetUnit.Unit == Unit.VrmsKrpm) {
          finalValue = this.VPkKRPMTovKRPM(sourceValue);
        }
        
        break;
      case Unit.mVRPM:
        finalValue = sourceValue;
        break;
      case Unit.s:
        if (targetUnit.Unit == Unit.min) {
          finalValue = this.SecondsToMinutes(sourceValue);
        }
        else if (targetUnit.Unit == Unit.mHZ) {
          finalValue = this.SecondsToMHZ(sourceValue);
        }
        break;
      case Unit.Vrms:
        if (targetUnit.Unit == Unit.V) {
          return sourceValue;
        } else if (targetUnit.Unit == Unit.Vpk) {
          finalValue = this.VrmsToVPk(sourceValue);
        }
        break;
      case Unit.A:
        if (targetUnit.Unit == Unit.Arms) {
          finalValue = sourceValue;
        }
        else if (targetUnit.Unit == Unit.APeak) {
          finalValue = this.AToAPeak(sourceValue);
        }
        break;
      case Unit.bits:
        finalValue = this.bitsToRevolutions(sourceValue);
        break;
      case Unit.kgMSQ:
        if (targetUnit.Unit == Unit.kgCMSQ) {
          finalValue = this.kgMSQTokgCMSQ(sourceValue);
        }
        else if (targetUnit.Unit == Unit.lbFtSQ) {
          finalValue = this.kgMSQTolbFtSQ(sourceValue);
        }
        else if (targetUnit.Unit == Unit.lbInSQ) {
          finalValue = this.kgMSQTolbInSQ(sourceValue);
        }
        break;
      case Unit.lbFtSQ:
        if (targetUnit.Unit == Unit.lbInSQ) {
          finalValue = this.lbFtSQTolbInSQ(sourceValue);
        }
        else if (targetUnit.Unit == Unit.kgCMSQ) {
          finalValue = this.lbFtSQTokmCMSQ(sourceValue);
        }
        else if (targetUnit.Unit == Unit.kgMSQ) {
          finalValue = this.lbFtSQTokgMSQ(sourceValue);
        }
        break;

      case Unit.lbFtA:
        if (targetUnit.Unit == Unit.inlbAPeak) {
          finalValue = this.lbFtATolbInA(sourceValue);
        }
        else if (targetUnit.Unit == Unit.NmA) {
          finalValue = this.lbFtToNm(sourceValue);
        }
        break;
      case Unit.lbInSQ:

        break;
      case Unit.mHZ:
        finalValue = sourceValue / 1000.0;
        break;
      case Unit.mVrmsRPM:

        break;
      case Unit.poles:
        finalValue = this.PolesToPolePairs(sourceValue);
        break;
      case Unit.polepairs:
      case Unit.pair:
        finalValue = this.PolePairsToPoles(sourceValue);
        break;
      case Unit.NmArms:
        finalValue = this.NmAToNmAPeak(sourceValue);
        break;
      
      case Unit.V:
        finalValue = this.VrmsToVPk(sourceValue);
        break;
      case Unit.vKRPM:
        finalValue = this.vKRPMTomVRPM(sourceValue);
        break;
        
      case Unit.VrmsKrpm:
        if (targetUnit.Unit == Unit.V) {
          finalValue = this.vRMSToV(sourceValue);
        }
        else if (targetUnit.Unit == Unit.vPeakKRPM) {
          finalValue = this.VrmsToVPk(sourceValue);
        }
        break;
      case Unit.blank:
      case Unit.CW:
      case Unit.Ohms:
      case Unit.radSSQ:
      case Unit.RPM:


      default:
        finalValue = sourceValue;
        break;
    }

    return finalValue;
  }

  public bitsToRevolutions(bits: number): number {
    return Math.pow(2, bits);
  }

  public RevolutionsToBits(revs: number): number {
    return Math.log(2) / Math.log(revs);
  }

  public bitsToTurns(bits: number): number {
    return Math.pow(2, bits);
  }

  public SinePPRToInterpolationFactor(ppr: number): number {
    return Math.log2(1048576 / ppr);
  }

  public SinePPRToFeedbackCyclesPerRev(ppr: number): number {
    return 0;
  }
  //distance
  public InToMm(inch: number): number {
    return inch * 25.4;
  }
  public MmToIn(mm: number): number {
    return mm / 25.4;
  }
  //Mass
  public LbToKg(lb: number): number {
    return lb * 0.4535237;
  }

  public KgToLb(kg: number): number {
    return kg / 0.4535237;
  }

  //Time
  public SecondsToMinutes(sec: number): number {
    return sec / 60.0;
  }
  public MinutesToHours(mins: number): number {
    return mins / 60.0;
  }

  public SecondsToMHZ(sec: number): number {
    return (1000.0) / ((2.0 * Math.PI) * sec / 30.0);
  }

  public HoursToDays(hours: number): number {
    return hours / 24.0;
  }

  public HoursToMinutes(hours: number): number {
    return hours * 60.0;
  }

  public MinutesToSec(mins: number): number {
    return mins * 60.0;
  }

  public DaysToHours(days: number): number {
    return days * 24.0;
  }

  //Speed constant
  public VPkKRPMTovKRPM(vpkKRPM: number): number {
    return vpkKRPM / Math.SQRT2;
  }

  public vKRPMTomVRPM(vkRPM: number): number {
    return vkRPM;
  }

  public mvRPMTomVRMSRPM(mvRPM: number): number {
    return mvRPM;
  }

  //Torque Constant
  public NmAPKToNmA(nmAPK: number): number {
    return nmAPK * Math.SQRT2;
  }

  public NmAToNmAPeak(nmA: number): number {
    return nmA / Math.SQRT2;
  }

  public NmAPeakToInLbAPeak(nM: number): number {
    return nM / 0.1129848;
  }

  public InLbAPeakToNmAPeak(inLB: number): number {
    return inLB * 0.1129848;
  }

  public NmToInLb(nm: number): number {
    return nm / 0.1129848;
  }

  public InLbToNm(inLb: number): number {
    return inLb * 0.1129848;
  }

  public lbFtAToNMAPeak(lbFTA: number): number {
    return this.AToAPeak(this.lbFtToNm(lbFTA));
  }

  public lbFtATolbInA(lbftA: number): number {
    return lbftA * 12.0;
  }

  public lbInATolbFtA(lbInA: number): number {
    return lbInA / 12.0;
  }

  public lbFtToNm(lbFt: number): number {
    return lbFt * 1.355818;
  }

  //voltage
  public vRMSToV(vRMS: number): number {
    return vRMS;
  }

  public vPkToV(vPk: number): number {
    return vPk / Math.SQRT2;
  }

  public vPkTovRMS(vPk: number): number {
    return vPk / Math.SQRT2;
  }
  public VrmsToVPk(vRMS: number): number {
    return vRMS * Math.SQRT2;
  }

  //Current
  public aRMSToA(aRMS: number): number {
    return aRMS;
  }
  public aPkToA(aPk: number): number {
    return aPk / Math.SQRT2;
  }

  public ArmsToAPeak(arms: number): number {
    return arms * Math.SQRT2;
  }

  public AToAPeak(a: number): number {
    return a * Math.SQRT2;
  }

  //MotorPoles
  public PolePairsToPoles(pairs: number): number {
    return pairs * 2.0;
  }
  public PolesToPolePairs(poles: number): number {
    return poles / 2.0;
  }

  //Resistance and Inductance
  public LLtoLN(LL: number): number {
    return LL / Math.sqrt(3);
  }
  public PPToLN(PP: number): number {
    return PP / Math.sqrt(3);
  }

  //Inertia
  public kgcmSqTokgMSq(kgcmSq: number): number {
    return kgcmSq / 10000;
  }

  public kgMSQTokgCMSQ(kgMSQ: number): number {
    return kgMSQ * 10000;
  }

  public kgMSQTolbFtSQ(kgmSQ: number): number {
    return kgmSQ * 23.73036;
  }

  public lbFtSQTokgMSQ(lbFtSQ: number): number {
    return lbFtSQ / 23.73036;
  }

  public kgMSQTolbInSQ(kgmSQ: number): number {
    return kgmSQ * 3417.1719;
  }
  public lbInSQTokgMSQ(lbInSQ: number): number {
    return lbInSQ * 3417.1719;
  }
  public kmcmSqToLbFSq(kgcmSq: number): number {
    return kgcmSq * 0.002373036;
  }

  public lbFtSQTokmCMSQ(lbFtSQ: number): number {
    return lbFtSQ / 0.002373036;
  }

  public lbinSqTolbFtSq(lbinSq: number): number {
    return lbinSq * 0.00694;
  }
  public lbFtSQTolbInSQ(lbFtSQ: number): number {
    return lbFtSQ / 0.00694;
  }

  public KgCMSqToLbIn(kg: number): number {
    return kg / 2.926396534;
  }

  public LbInToKgCMSq(lbIn: number): number {
    return lbIn * 2.926396534;
  }

  public kgcmSqToYaskawaValue(kgcmSq: number) {
    return Math.pow(10, -4.0 * this.kgcmSqTokgMSq(kgcmSq) * 0.0001);
  }

  //Power
  public KWToHP(kw: number): number {
    return kw / 1.341022;
  }

  public HPToKW(hp: number): number {
    return hp * 1.341022;
  }

  //Temperature
  public FahrToCelc(f: number): number {
    return (f - 32) * (5 / 9);
  }

  public CelcToFahr(c: number): number {
    return ((9 / 5) * c) + 32;
  }

  //Frequency
  public kHzToHz(kh: number): number {
    return kh / 1000.0;
  }

  public HzTokHZ(h: number): number {
    return h * 1000.0;
  }

  //Coil Thermal Constant
  public TTCToCTC(TTC: number): number {
    return (1000.0 / (2 * Math.PI * TTC / 30.0));
  }

}
